export default __webpack_public_path__ + "static/media/Image25.759a926e.png";